webpackJsonp([32],{

/***/ "+1ys":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ZdaW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1DHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");
var clean_style_default = /*#__PURE__*/__webpack_require__.n(clean_style);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return clean_style_default()({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': Object(get_parent_prop["a" /* default */])(this, 'justify') === 'justify'
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return clean_style_default()({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': Object(get_parent_prop["a" /* default */])(this, 'justify') === 'justify'
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bf960f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_cell = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("2rkV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_cell,
  src_components_cell,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2UcR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2rkV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5TPd":
/***/ (function(module, exports) {

/**
 * Created by desheng.zhao on 2018/6/13.
 */
var date = function date(timestamp) {
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

    var _date = new Date(timestamp);
    var y = _date.getFullYear();
    var m = _date.getMonth() + 1;
    var d = _date.getDate();
    return "" + y + sep + doubleNum(m) + sep + doubleNum(d);
};
var doubleNum = function doubleNum(n) {
    if (n.length > 2 || n > 100) {
        return n;
    }
    n = parseInt(n);
    return n >= 10 ? "" + n : "0" + n;
};

var time = function time(timestamp) {
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ":";

    var _date = new Date(timestamp);
    var h = _date.getHours();
    var m = _date.getMinutes();
    var s = _date.getSeconds();
    return doubleNum(h) + sep + doubleNum(m) + sep + doubleNum(s);
};

var dateTime = function dateTime(timestamp) {
    var dateSep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
    var timeSep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ":";

    return date(timestamp, dateSep) + " " + time(timestamp, timeSep);
};
module.exports = {
    date: date,
    time: time,
    dateTime: dateTime,
    doubleNum: doubleNum
};

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus() {
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus() {
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd36e826","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt",on:{"touchstart":function($event){$event.preventDefault();_vm.setInputFocus($event)}}},[_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.msg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.inputAttrs,false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("j9pJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AROH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BaqE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e64af1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading"},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({ position: _vm.position })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("2UcR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BtWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by desheng.zhao on 2018/7/16.
 */
/* harmony default export */ __webpack_exports__["a"] = (function (url) {
    if (!url) {
        console.warn("缺少url参数");
        return;
    }
    var oA = document.createElement("a");
    oA.target = '_self';
    oA.href = url;
    var oSpan = document.createElement('span');
    oSpan.innerText = '跳转';
    oA.append(oSpan);
    oA.style.display = "none";
    document.body.append(oA);
    // oA.click();
    oSpan.click();
    oA.remove();
});

/***/ }),

/***/ "IDPw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var filters_namespaceObject = {};
__webpack_require__.d(filters_namespaceObject, "getDayFormatTime", function() { return getDayFormatTime; });
__webpack_require__.d(filters_namespaceObject, "decimal", function() { return filters_decimal; });
__webpack_require__.d(filters_namespaceObject, "hidePhoneNum", function() { return hidePhoneNum; });
__webpack_require__.d(filters_namespaceObject, "getFormatTime", function() { return getFormatTime; });

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      transitionName: "slide",
      hideHeader: false,
      routerStack: new set_default.a(),
      direction: "" //页面滑动方向： left right 空
    };
  },

  watch: {
    "$route": function $route(n, o) {
      //            console.log(n,o);
      //            console.log(this.routerStack)
      if (!this.routerStack.size) {
        // 第一次前进
        this.direction = "left";
        this.routerStack.add(n.name);
      } else if (!this.routerStack.has(n.name)) {
        // 新页面前进
        this.direction = "left";
        this.routerStack.add(n.name);
      } else {
        // 老页面后退
        this.direction = "right";
        this.routerStack.delete(o.name); // 后退后移除打开记录，下次进入就是前进
      }
    }
  },
  methods: {
    debug: function debug(ele, fn) {
      var count = 0;
      var timeRange = 2000;
      var beginTime, time;
      var that = this;
      ele.addEventListener("click", function () {
        if (count == 0) {
          beginTime = new Date().getTime();
          count++;
        } else {
          time = new Date().getTime();
          if (time - beginTime >= timeRange) {
            if (count >= 6) {
              fn.call(that);
              count = 0;
            } else {
              count = 0;
              beginTime = null;
            }
          } else {
            count++;
          }
        }
      }, false);
    }
  },
  mounted: function mounted() {
    if (this.$config.env !== "prod") {
      var that = this;
      this.debug(document, function () {
        that.$vux.toast.show({
          text: "已启用调试模式",
          type: "text",
          onHide: function onHide() {
            that.$router.push({ name: 'pagelist' });
          }
        });
      });
    }

    var userAgent = window.navigator.userAgent;
    // console.log("userAgent:",userAgent);
    var flag = false;
    for (var i = 0, len = this.$config.hideHeader.length; i < len; i++) {
      var reg = new RegExp(this.$config.hideHeader[i], "i");
      if (reg.test(userAgent)) {
        flag = true;
        break;
      }
    }
    if (flag) {
      this.hideHeader = true;
    } else {
      this.hideHeader = false;
    }

    //  'English': language == 'en', 'Chinese': language == 'zh'
    var lang = this.$cookie.get("lang");
    if (lang == "en-US") {
      document.body.classList.remove("Chinese");
      document.body.classList.add("English");
    } else if (lang == "zh-CN") {
      document.body.classList.remove("English");
      document.body.classList.add("Chinese");
    } else {
      document.body.classList.remove("English");
      document.body.classList.add("Chinese");
    }

    window.onerror = function (err) {
      that.$store.dispatch("addError", {
        page: that.$t(that.$router.currentRoute.meta.title),
        error: err
      });
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  data: function data() {
    return {
      transitionName: "slide",
      hideHeader: false,
      routerStack: new set_default.a(),
      direction: "" //页面滑动方向： left right 空
    };
  },

  watch: {
    "$route": function $route(n, o) {
      //            console.log(n,o);
      //            console.log(this.routerStack)
      if (!this.routerStack.size) {
        // 第一次前进
        this.direction = "left";
        this.routerStack.add(n.name);
      } else if (!this.routerStack.has(n.name)) {
        // 新页面前进
        this.direction = "left";
        this.routerStack.add(n.name);
      } else {
        // 老页面后退
        this.direction = "right";
        this.routerStack.delete(o.name); // 后退后移除打开记录，下次进入就是前进
      }
    }
  },
  methods: {
    debug: function debug(ele, fn) {
      var count = 0;
      var timeRange = 2000;
      var beginTime, time;
      var that = this;
      ele.addEventListener("click", function () {
        if (count == 0) {
          beginTime = new Date().getTime();
          count++;
        } else {
          time = new Date().getTime();
          if (time - beginTime >= timeRange) {
            if (count >= 6) {
              fn.call(that);
              count = 0;
            } else {
              count = 0;
              beginTime = null;
            }
          } else {
            count++;
          }
        }
      }, false);
    }
  },
  mounted: function mounted() {
    if (this.$config.env !== "prod") {
      var that = this;
      this.debug(document, function () {
        that.$vux.toast.show({
          text: "已启用调试模式",
          type: "text",
          onHide: function onHide() {
            that.$router.push({ name: 'pagelist' });
          }
        });
      });
    }

    var userAgent = window.navigator.userAgent;
    // console.log("userAgent:",userAgent);
    var flag = false;
    for (var i = 0, len = this.$config.hideHeader.length; i < len; i++) {
      var reg = new RegExp(this.$config.hideHeader[i], "i");
      if (reg.test(userAgent)) {
        flag = true;
        break;
      }
    }
    if (flag) {
      this.hideHeader = true;
    } else {
      this.hideHeader = false;
    }

    //  'English': language == 'en', 'Chinese': language == 'zh'
    var lang = this.$cookie.get("lang");
    if (lang == "en-US") {
      document.body.classList.remove("Chinese");
      document.body.classList.add("English");
    } else if (lang == "zh-CN") {
      document.body.classList.remove("English");
      document.body.classList.add("Chinese");
    } else {
      document.body.classList.remove("English");
      document.body.classList.add("Chinese");
    }

    window.onerror = function (err) {
      that.$store.dispatch("addError", {
        page: that.$t(that.$router.currentRoute.meta.title),
        error: err
      });
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d1b127","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'hide-header': _vm.hideHeader},attrs:{"id":"app"}},[_c('router-view',{staticClass:"pane-view"})],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("k6Vq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js
/**
 * Created by zhengyi.fu on 2018/6/4.
 */


vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
// console.log(Vue.prototype)
var testPage = [{
  path: "/test",
  name: "test",
  component: function component(resolve) {
    __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SvlD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    requireAuth: false,
    title: "测试页面"
  }
}, {
  path: "/cache",
  name: "cache",
  component: function component(resolve) {
    __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JAkf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    requireAuth: false,
    title: "缓存管理"
  }
}, {
  path: "/freshPage",
  name: "freshPage",
  component: function component(resolve) {
    __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AmCf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    requireAuth: false,
    title: "页面刷新测试"
  }
}, {
  path: "/systemMsg",
  name: "systemMsg",
  component: function component(resolve) {
    __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MGcY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    requireAuth: false,
    title: "系统信息"
  }
}, {
  path: "/input",
  name: "input",
  component: function component(resolve) {
    __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NTOJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    requireAuth: false,
    title: "输入框信息"
  }
}, {
  path: "/pagelist",
  name: "pagelist",
  component: function component(resolve) {
    Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("C2aP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    requireAuth: false,
    title: "页面列表" // "页面列表"
  }
}, {
  path: "/errorLog",
  name: "errorLog",
  component: function component(resolve) {
    __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8JE2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    requireAuth: false,
    title: "错误日志"
  }
}, {
  path: "/infoLog",
  name: "infoLog",
  component: function component(resolve) {
    __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kEeo")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    requireAuth: false,
    title: "日志"
  }
}];
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  // base: '/pss/',
  mode: 'history',
  routes: [{ path: '*', redirect: '/user' }, { path: "/", redirect: "/user" }, {
    path: "/user",
    name: "user",
    component: function component(resolve) {
      __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("md3T")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: false,
      title: "" // "个人中心" pages.userCenter 如果不寫title，則用上一次的title。 過渡頁面不寫title
    }
  }, {
    path: "/home",
    name: "home",
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EBCV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "home.title" // "个人中心"
    }
  }, {
    path: "/login",
    name: "login",
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XVVD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: false,
      title: "login.title" //"登录",
    }
  }, {
    path: "/emailLogin",
    name: "emailLogin",
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("L+tf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: false,
      title: "emailLogin.title"
    }
  }, {
    path: "/loginSuccess",
    name: "loginSuccess",
    component: function component(resolve) {
      __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NvRP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "loginSuccess.title" // "登录成功"
    }
  }, {
    path: "/reset",
    name: "reset",
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5sjJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: false,
      title: "reset.title" // "重置密码"
    }
  }, {
    path: "/register",
    name: "register",
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NxzY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: false,
      title: "register.title" // "注册"
    }
  }, {
    path: "/machine",
    name: "machine",
    component: function component(resolve) {
      __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("42kq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "pages.myMachine" // "我的设备"
    },
    children: [{
      path: "/machine/binding",
      name: "binding",
      component: function component(resolve) {
        __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("L5Wy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        requireAuth: true,
        title: "binding.title" // "绑定设备"
      }
    }, {
      path: "/machine/binded",
      name: "binded",
      component: function component(resolve) {
        __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("esU0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        requireAuth: true,
        title: "binded.title" //  "绑定成功"
      }
    }]
  }, {
    path: "/nosim",
    name: "nosim",
    component: function component(resolve) {
      __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("CDIn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "noSim.title"
    }
  }, {
    path: "/shareSimDetail",
    name: "shareSimDetail",
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Hy+v")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "shareDetail.title"
    }
  }, {
    path: "/withdraw",
    name: "withdraw",
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ihc2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "withdraw.title"
    }
  }, {
    path: "/withdrawRecord",
    name: "record",
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xrBg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "withdrawRecord.title"
    }
  }, {
    path: "/historyOrder",
    name: "historyOrder",
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NaTu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "historyOrders.title"
    }
  }, {
    path: "/orderDetail",
    name: "orderDetail",
    component: function component(resolve) {
      __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("H4tz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "orderDetail.title"
    }
  }, {
    path: "/policy",
    name: "policy",
    component: function component(resolve) {
      __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eQ54")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: false,
      title: "policy.title"
    }
  }, {
    path: "/agreement",
    name: "agreement",
    component: function component(resolve) {
      __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Pfa1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: false,
      title: "agreement.title"
    }
  }, {
    path: "/setting",
    name: "setting",
    component: function component(resolve) {
      __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9D4b")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: false,
      title: "setting.title"
    }
  }, {
    path: "/changeLanguage",
    name: "changeLanguage",
    component: function component(resolve) {
      __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("96by")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: false,
      title: "changeLanguage.title"
    }
  }, {
    path: "/reservationCode",
    name: "reservationCode",
    component: function component(resolve) {
      __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EOy+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "reservationCode.title"
    }
  }, {
    path: "/addMachine",
    name: "addMachine",
    component: function component(resolve) {
      __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("L5Wy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: true,
      title: "binding.title" // "绑定设备"
    }
  }, {
    path: "/instruction",
    name: "instruction",
    component: function component(resolve) {
      __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M3GH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      requireAuth: false,
      title: "instruction.title" // "绑定设备"
    }
  }].concat(testPage)
}));
// CONCATENATED MODULE: ./src/config/config.js
/**
 * 公共参数的配置文件
 * **/

var pssApi = {
  // 登录相关接口
  getPicRandomCode: "/pss/getPicRandomCode", // 获取图片验证码
  getVerificationCode: "/pss/getVerificationCode", // 获取短信验证码
  login: "/pss/login", // 登录
  register: "/pss/register", // 注册
  findPwd: "/pss/findPwd ", // 找回密码

  // 设备相关接口
  bindDevice: "/pss/bindDevice", // 绑定设备
  getDeviceMsg: "/pss/getDeviceMsg", // 查询设备里面的卡信息
  accountDevice: "/pss/accountDevice", // 查询绑定关系
  shareFlow: "/pss/shareFlow", // 根据设备查询卡
  searchCard: "/pss/searchCard", // 查询卡详情
  confirmShare: "/pss/confirmShare", // 确认分享
  cancelShare: "/pss/cancelShare", // 取消分享
  unbindDevice: "/pss/unbindDevice", // 解绑设备
  getUserDeviceList: "/pss/getUserDeviceList", // 查询设备列表

  getShareTip: "/pss/getShareTip", // 分享提示

  // 提现相关接口
  userWithdrawCash: "/pss/userWithdrawCash", // 提现
  getUserBalance: "pss/getUserBalance", // 查询可提现金额
  searchUserHistoryOrder: "/pss/searchUserHistoryOrder", // 历史订单
  getUserWithdrawCashList: "/pss/getUserWithdrawCashList", // 提现记录

  // 字典
  queryDictionary: "/pss/queryDictionary", // 字典(参数type)

  // 预约码
  checkUserCode: "/pss/checkUserCode", // 校验是否已经授权
  validateUserCode: "/pss/validateUserCode" // 校验预约码是否正确
};

var config_config = {
  api: pssApi
};

/* harmony default export */ var src_config_config = (config_config);
// EXTERNAL MODULE: ./src/utils/cookie.js
var cookie = __webpack_require__("iPXC");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./src/data/app-config.js

/**
 * @author huancheng.zhan<zhanhuancheng@ukelink.com>
 * @date 2018/4/9
 * @description
 */
var app_config_get = function get(url) {
    return new promise_default.a(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.onload = function () {
            if (xhr.status == 200) {
                resolve(JSON.parse(xhr.responseText));
            } else {
                reject(null);
            }
        };
        xhr.onerror = function () {
            reject(null);
        };
        xhr.send(null);
    });
};
/* harmony default export */ var app_config = ({
    getConfig: function getConfig() {
        var hash = Math.random();
        return app_config_get("/config/app-config.json?hash=" + hash);
        // return get(`/wifi/config/app-config.json?hash=${hash}`);
    }
});
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/store/errorLog.js

/**
 * Created by desheng.zhao on 2019/6/17.
 */


var errorLog = {
  state: {
    errors: {}
  },
  mutations: {
    addError: function addError(state, payload) {

      if (Array.isArray(state.errors[payload.page])) {
        // state.errors[payload.page].push(payload.error);
        vue_esm["a" /* default */].set(state.errors, payload.page, state.errors[payload.page].concat(payload.error));
      } else {
        // state.errors[payload.page] = [payload.error];
        vue_esm["a" /* default */].set(state.errors, payload.page, [payload.error]);
      }
    }
  },
  actions: {
    addError: function addError(state, payload) {
      if (Object.prototype.toString.call(payload.error) != "[object Error]") {
        payload.error = new Error(payload.error);
      }

      payload.error.page = payload.page;
      state.commit("addError", payload);
    }
  },
  getters: {
    allError: function allError(state) {
      var errs = [];
      console.log(state);
      var obj = state.errorLog ? state.errorLog.errors : state.errors;
      keys_default()(obj).forEach(function (item) {
        errs = errs.concat(obj[item]);
      });
      return errs;
    },
    pageError: function pageError(state) {
      return function (page) {
        return state.errors[page];
      };
    },
    hasErrorPages: function hasErrorPages(state) {
      var obj = state.errorLog ? state.errorLog.errors : state.errors;
      return keys_default()(obj);
    }
  }
};

/* harmony default export */ var store_errorLog = (errorLog);
// CONCATENATED MODULE: ./src/store/infoLog.js

/**
 * Created by desheng.zhao on 2019/6/17.
 */


var infoLog = {
  state: {
    infos: {} // {home: [{info: "系统类型ios"}], {withdraw: [{info: "提现金额500"},{info: "总金额800"}]}}
  },
  mutations: {
    // 新增info   payload: {page: "首页",info: "调用接口成功"} => payload: {page: "首页",info: {message:"调用接口成功",page:"首页"}}
    addInfo: function addInfo(state, payload) {
      payload.info = {
        message: payload.info,
        page: payload.page
      };
      if (Array.isArray(state.infos[payload.page])) {
        vue_esm["a" /* default */].set(state.infos, payload.page, state.infos[payload.page].concat(payload.info));
      } else {
        vue_esm["a" /* default */].set(state.infos, payload.page, [payload.info]);
      }
    }
  },
  actions: {
    addInfo: function addInfo(state, payload) {
      state.commit("addInfo", payload);
    }
  },
  getters: {
    // 返回所有的info
    allInfo: function allInfo(state) {
      var infos = [];
      var obj = state.infos;
      keys_default()(obj).forEach(function (item) {
        infos = infos.concat(obj[item]);
      });
      return infos;
    },
    // 按页面返回info
    pageInfo: function pageInfo(state) {
      return function (page) {
        return state.infos[page];
      };
    },

    // 返回有info的页面
    hasInfoPages: function hasInfoPages(state) {
      var obj = state.infos;
      return keys_default()(obj);
    }
  }
};

/* harmony default export */ var store_infoLog = (infoLog);
// CONCATENATED MODULE: ./src/store/wechat.js
/**
 * Created by desheng.zhao on 2019/6/18.
 */
var wechat = {
  state: {
    iswechat: ""
  },
  mutations: {
    wechat: function wechat(state, payload) {
      state.iswechat = payload;
    }
  },
  actions: {
    wechat: function wechat(state, payload) {
      state.commit("wechat", payload);
    }
  },
  getters: {
    wechat: function wechat(state) {
      return state.iswechat;
    }
  }
};

/* harmony default export */ var store_wechat = (wechat);
// CONCATENATED MODULE: ./src/store/index.js





vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
    modules: {
        wechat: store_wechat,
        errorLog: store_errorLog,
        infoLog: store_infoLog
    }
});

/* harmony default export */ var src_store = (store);
// CONCATENATED MODULE: ./src/lang/en.js
/**
 * Created by desheng.zhao on 2019/2/21.
 */

// 按页面划分
/* harmony default export */ var en = ({
  // 公共页面
  common: {
    fill: "Required",
    fillError: "Invalid",
    fillHasError: "The field is empty or invalid",
    ajaxError: "Something went wrong",
    networkError: "Network unavailable",
    tokenExpire: "You haven\'t logged in, or your previous session has expired"
  },
  //邮箱登录
  emailLogin: {
    title: 'Login',
    subTitle: "Login with Email",
    emailAccount: "Email",
    password: "Password",
    emailEmpty: "Please enter your email",
    emailError: "Invalid email",
    checkEmail: "Invalid email"
  },
  // 登录
  login: {
    title: "Login",
    subTitle: "Login with Mobile",
    phoneNo: "Phone number",
    password: "Password",
    msgCode: "SMS verification code",
    getMsgCode: "Get Code",
    getMsgInterval: "s later to resend",
    loginBtn: "Login",
    registerBtn: "Register",
    resetBtn: "Forgot Password",
    phoneEmpty: "Please enter your phone number",
    phoneError: "Invalid phone number",
    checkPhone: "Invalid phone number",
    fillMsgCode: "Please enter the SMS verification code",
    fillPassword: "Please enter the password",
    fill: "Required",
    fillError: "Invalid",
    hasError: "The field is empty or invalid",
    loginSuccess: "Login successful",
    needMsgCheck: "A verification code is required to log in"

  },
  // 注册
  register: {
    title: "Register",
    subTitle: "Register via Mobile",
    phoneNo: "Phone number",
    password: "Password must be 6-20 characters long",
    repeatPwd: "Confirm password",
    msgCode: "SMS verification code",
    getMsgCode: "Get Code",
    getMsgInterval: "s later to resend",
    picCode: "Image verification code",
    getPicCode: "Get Code",
    registerBtn: "Register",
    auth: {
      tip: "By registering you have read and agreed to the",
      agreeMent: "User Agreement",
      and: "and",
      policy: "Privacy Policy"
    },
    footer: "For any questions, please contact us on WeChat",

    phoneEmpty: "Please enter your phone number",
    phoneError: "Invalid phone number",
    fillPassword: "Please enter your password", //"Password must be 6-20 characters long",
    pwdInvalidLetter: "Password contains invalid characters",
    pwdLenLow: "Password must be greater than 6 characters long",
    pwdNeedLetter: "Password must contain letters or special characters",
    pwdNeedNum: "Password must contain digits",
    pwdLenUp: "Password must be less than 20 characters long",
    fillRepeatPwd: "Please re-enter the password",
    RepeatPwdError: "Passwords do not match",
    fillMsgCode: "Please enter the SMS verification code",
    fillPicCode: "Please enter the image verification code",
    getPicCodeFirst: "Please obtain the image verification code first",
    registSuccess: "Registration successful"

  },
  // 找回密码
  reset: { // 找回密码很多字段和注册一样，就直接调用注册的
    title: "Reset Password",
    subTitle: "Reset Password",
    resetBtn: "Confirm & Login"

  },
  // 登录成功
  loginSuccess: {
    title: "Login successful",
    logAccount: "You are logged in",
    toBindBtn: "Link device",
    toShareBtn: "Share data",
    logOutBtn: "Log out",
    footer: "If you have no device, please contact us on WeChat",

    isLogout: "Are you sure you want to log out?",
    confirmText: "Confirm",
    cancelText: "Cancel",
    logOutSuccess: "You have logged out successfully"
  },
  // 绑定设备
  binding: {
    title: "Link device",
    imei: "Device IMEI",
    fillImei: "Please enter the device IMEI",
    password: "Device password",
    fillPwd: "Please enter the device password",
    bindBtn: "Link Now",
    needImei: "Please enter the device IMEI",
    needPwd: "Please enter the device password"
  },
  // 绑定设备成功
  binded: {
    title: "Linked successfully",
    bindedMachine: "Device is linked successfully",
    toShare: "Share SIM data",
    unbind: "Unlink",
    unbindSuccess: "Unlink successfully",
    isUnbind: "Do you want to unlink the device？",
    confirmText: "Confirm",
    cancelText: "Cancel"
  },
  // 卡分享详情
  shareDetail: {
    title: "Data sharing details",
    imei: "Device IMEI",
    online: "Online",
    offline: "Offline",
    tip: "Tips",
    footer: "For any questions, please contact us on WeChat",
    submitSuccessTip: "Submission successful. The order is being processed. Please confirm and share after approval.",
    alertButtonText: "OK",
    offlineOperateTip: "Unable to operate when device is offline",
    offlineTip: "The device is offline and please check the device status . For any questions, please join our QQ group for assistance，",
    unbindedTip: "This device has been unlinked and please link again",
    cancelSuccess: "Successfully cancelled",

    simShareInfo: { // sim-share-info
      simShareInfo: "Data sharing details",
      phone: "Phone number",
      flow: "Share data",
      price: "Price",
      shareEndTime: "Valid until",
      cancelShareBtn: "Don't share",
      confirmShareBtn: "Confirm & Share"
    },

    simShareSuccess: {
      shareSuccess: "Successfully shared",
      tip: "To ensure the data sharing, please keep your device stay online",
      alertBtnText: "OK"
    },

    submitSimInfo: {
      title: "Enter the SIM information",
      phone: "Phone number",
      phonePh: "Phone number", // ph  placeholder
      flow: "Share data",
      flowPh: "{flow}GB below",
      shareEndTime: "Valid until",
      shareEndTimePh: "Expire on",

      operator: "Carrier",
      operatorPh: "Select carrier",
      pickerConfirmText: "Confirm",
      pickerCancelText: "Cancel",

      cancelBtn: "Cancel",
      submitBtn: "Submit",

      needPhone: "Please enter your phone number",
      phoneError: "Invalid phone number",
      needFlow: "Please enter the sharing data limit",
      flowTip: "The data limit must be an integer less than {flow}",
      flowCannot0: "The data limit cannot be 0",
      flowCannotMinus: "The data limit cannot be minus",
      fillShareEndTime: "Please enter the expiration date",
      selectOperator: "Please select a carrier"
    },

    oneSim: {
      dataError: "Error. ",
      tryAgain: "Refresh",
      loading: "Loading……",
      detectedSim: "SIM detected",
      toShare: "Share",
      detectedNoSim: "No SIM",
      enterSim: "Please install the SIM card",
      status00: "Waiting sharing",
      status01: "Pending",
      status02: "Approved. Please confirm",
      status03: "Rejected",
      status04: "Sharing",
      status05: "Interrupted",
      status06: "Re-share",
      status07: "Cancel",
      status08: "SIM abnormal"
    }
  },
  // 提现记录
  withdrawRecord: {
    title: "Withdrawal History ",
    totalProfit: "Total bonuses",
    canWithdrawAmount: " Available balance (CNY)",
    withdraw: "Withdraw",
    withdrawRecord: "Withdrawal history",
    withdrawAmount: "Amount withdrawn",
    moreRecord: "View more",
    noMoreData: "sorry, no more data to display",
    footer: "For any questions, please contact us on WeChat",
    cannotWithdraw: "You haven’t shared any data yet. Try to share it",
    noRecord: "No records",
    contactMe: "Please follow 插卡宝 on WeChat or add QQ ID 738605106 for customer service"
  },
  // 提现
  withdraw: {
    title: "Withdrawal",
    canWithdrawAmountTip: "Amount to withdraw (CNY)",
    withdrawPre: "￥",
    // amountPh: "Please enter the withdrawal amount",
    amountPh: "Enter the withdrawal amount",
    canWithdrawAmount: "Available balance {amount}",
    withdrawAll: "Withdraw all",
    withdrawTo: "Withdraw to",
    wechatWallet: "WeChat Wallet",
    sendMethod: "By Red Packet", // "Red packet sent",
    nameConfirm: "Verify identity",
    namePh: "Please enter your real name",
    withdrawBtn: "Withdraw",
    tip: "The remittance is available from 11:00 to 18:00 on Friday (excluding public holidays)",
    footer: "For any questions, please contact us on WeChat",

    needName: "Please enter your real name",
    withdrawTip: "Request received. The amount will be transferred to you on Friday. For any questions, please join our QQ group for assistance. {QQ}",
    alertButtonText: "OK",
    needAmount: "Please enter the withdrawal amount ",
    amountIsNaN: " The withdrawal amount must be digits ",
    amountLg: " Withdrawal beyond available amount",
    twoDecimalPlaces: "It only supports 2 decimal places ",
    amountNegative: "The withdrawal amount cannot be negative",
    amountIs0: "The withdrawal amount cannot be 0",
    usernameError: "Invalid username"
  },
  // 历史订单
  historyOrders: {
    title: " Order History",
    createOrderTime: "Order Date",
    sharedFlow: "Data Shared",
    moreOrder: "View more",
    noMoreData: " sorry, no more data to display ",
    footer: " For any questions, please contact us on WeChat",
    noOrder: "You haven't placed any orders yet"
  },
  // 订单详情
  orderDetail: {
    title: "Order Details ",
    phone: "Phone No. ",
    flow: "Data Shared",
    createOrderTime: "Order Date",
    price: "Data Rate",
    orderId: "Order ID ",
    footer: "For any questions, please contact us on WeChat"
  },
  // 无设备
  noSim: {
    title: "Data sharing details",
    noCard: "No SIM available",
    toBind: "Already have a device. Link now",
    footer: "If you have no device, please contact us on WeChat"
  },
  // 设置
  setting: {
    title: "Settings",
    device: "My device",
    language: "Language",
    logOut: "Logout"
  },
  // 切换语言
  changeLanguage: {
    title: "Language"
  },
  // 隐私政策
  policy: {
    title: "Privacy Policy"
  },
  // 切换语言
  agreement: {
    title: "User Agreement"
  },
  // 首页
  home: {
    title: "Data Share",
    totalFit: "Total bonuses",
    withdraw: "Withdraw",
    withdrawHistory: "Withdrawal history",
    historyOrder: "Order history",
    instruction: "Guidelines",
    myDevices: "My devices",
    boxName: "SIMBOX",
    online: "Online",
    offline: "Offline",
    imeiNum: "IMEI No.",
    addDevice: "Scan QR code to add device",
    noDevice: "There are currently no linked devices",
    noFit: "No bonuses",
    noSignal: "No signal",
    profitUnit: "CNY",
    unknownPhone: "Unknown device",
    openInApp: "This function is only available on SIMBOX App"
  },
  // 预约码
  reservationCode: {
    title: "Data share",
    inputCodeTip: "Enter your reservation code",
    noCode: "If you don't have the reservation code, contact customer service.",
    codePlaceholder: "Enter your reservation code",
    btnText: "Confirm",
    auth: {
      tip: "By clicking Confirm, you have read and agree to the ",
      agreeMent: "User Agreement",
      and: "and",
      policy: "Privacy Policy"
    },
    validateSuccess: "Verification successful"
  },
  // 使用说明
  instruction: {
    title: "Guidelines",
    step1: "1. Open your GlocalMe Call app, go to Me > SIM  Manager > Share SIM card, and then tap \"Share data\"",
    step1Remark: "(Note: Once enabled, it will affect your ability to access calls or messages temporarily, and you can cancel it at any time before you submit the request)",
    step2: "2. Tap \"Confirm\" or tap \"Share data\" on the \"Me\" page to submit your request;",
    step3: "3. On the \"Share data\" page, you can proceed to share data. Once the request is approved, you will be able to view the sharing status and amount.",
    readBtn: "OK，got it"
  },
  // 所有的过渡页面
  pages: {
    userCenter: "Me",
    myMachine: "My device"
  }
});
// CONCATENATED MODULE: ./src/lang/zh.js
/**
 * Created by desheng.zhao on 2019/2/21.
 */

// 按页面划分
/* harmony default export */ var zh = ({
  // 公共页面
  common: {
    fill: "请填写",
    fillError: "填写错误",
    fillHasError: "表单填写不完整",
    ajaxError: "数据出错了",
    networkError: "网络出错啦~",
    tokenExpire: "登录信息已失效或未登录"
  },
  //邮箱登录
  emailLogin: {
    title: '邮箱登录',
    subTitle: "邮箱登录",
    emailAccount: "邮箱",
    password: "密码",
    emailEmpty: "请填写邮箱",
    emailError: "邮箱填写错误",
    checkEmail: "请检查邮箱"
  },
  // 手机登录
  login: {
    title: "登录",
    subTitle: "手机登录",
    phoneNo: "手机号",
    password: "密码",
    msgCode: "验证码",
    getMsgCode: "获取验证码",
    getMsgInterval: "s后可重新获取", // 这里的s是秒的意思
    loginBtn: "登录",
    registerBtn: "注册",
    resetBtn: "忘记密码",
    phoneEmpty: "请填写手机号",
    phoneError: "手机号填写错误",
    checkPhone: "请检查手机号",
    fillMsgCode: "请填写手机验证码",
    fillPassword: "请填写密码",
    fill: "请填写",
    fillError: "填写错误",
    hasError: "表单填写不完整或有误",
    loginSuccess: "登录成功",
    needMsgCheck: "本次登录需要短信验证码验证"
  },
  // 注册
  register: {
    title: "注册",
    subTitle: "手机注册",
    phoneNo: "手机号码",
    password: "设置6-20位密码",
    repeatPwd: "再次确认密码",
    msgCode: "验证码",
    getMsgCode: "获取验证码",
    getMsgInterval: "s后可重新获取", // 这里的s是秒的意思
    picCode: "请输入图片识别码",
    getPicCode: "获取图片验证码",
    registerBtn: "注册",
    auth: {
      tip: "注册即表示您已阅读并同意",
      agreeMent: "用户协议",
      and: "和",
      policy: "隐私政策"
    },
    footer: "如有疑问，可在公众号中反馈",

    phoneEmpty: "请填写手机号",
    phoneError: "手机号填写错误",
    fillPassword: "请填写密码",
    pwdInvalidLetter: "密码中包含不合法的符号",
    pwdLenLow: "密码不可小于6位",
    pwdNeedLetter: "密码需包含字母或特殊符号",
    pwdNeedNum: "密码需包含数字",
    pwdLenUp: "密码长度超过最大20位限制",
    fillRepeatPwd: "请填写确认密码",
    RepeatPwdError: "两次密码不一致",
    fillMsgCode: "请填写手机验证码",
    fillPicCode: "请填写图片验证码",
    getPicCodeFirst: "请先获取图片验证码",
    registSuccess: "注册成功"
  },
  // 找回密码
  reset: { // 找回密码很多字段和注册一样，就直接调用注册的
    title: "重置密码",
    subTitle: "重置密码",
    resetBtn: "确认修改并登录"
  },
  // 登录成功
  loginSuccess: {
    title: "登录成功",
    logAccount: "账号已登录",
    toBindBtn: "去绑定设备",
    toShareBtn: "去分享流量",
    logOutBtn: "退出账号",
    footer: "若无设备，请联系公众号客服",

    isLogout: "是否要退出当前账号？",
    confirmText: "确定",
    cancelText: "取消",
    logOutSuccess: "退出账号成功"
  },
  // 绑定设备
  binding: {
    title: "绑定设备",
    imei: "设备编码：",
    fillImei: "请输入设备IMEI号",
    password: "设备密码：",
    fillPwd: "请输入设备密码",
    bindBtn: "立即绑定",
    needImei: "请填写设备编码",
    needPwd: "请填写设备密码"
  },
  // 绑定设备成功
  binded: {
    title: "绑定成功",
    bindedMachine: "已绑定设备",
    toShare: "去分享卡流量",
    unbind: "解除绑定",
    unbindSuccess: "解除绑定成功",
    isUnbind: "是否要解除设备绑定？",
    confirmText: "确定",
    cancelText: "取消"
  },
  // 卡分享详情
  shareDetail: {
    title: "卡分享详情",
    imei: "设备号",
    online: "在线",
    offline: "离线",
    tip: "温馨提示",
    footer: "如有疑问，请联系公众号客服解决",
    submitSuccessTip: "提交申请成功，客服将尽快给您审核派单，请您稍等一下，派单后需要您再次确认哦~",
    alertButtonText: "确定",
    offlineOperateTip: "设备离线状态下不可以操作哦~",
    offlineTip: "您的设备已离线，请检查设备状态，离线将影响您的卡分享收益，如有疑问，请添加以下Q群联系客服解决。",
    unbindedTip: "此设备已被解绑，请重新绑定",
    cancelSuccess: "取消成功",

    simShareInfo: { // sim-share-info
      simShareInfo: "卡分享信息",
      phone: "号码",
      flow: "分享流量",
      price: "单价",
      shareEndTime: "分享日期至",
      cancelShareBtn: "取消分享",
      confirmShareBtn: "确认分享"
    },

    simShareSuccess: {
      shareSuccess: "分享成功",
      tip: "分享期间请保持设备的开启状态，保证稳定供卡",
      alertBtnText: "确定"
    },

    submitSimInfo: {
      title: "填写分享卡的套餐信息",
      phone: "号码",
      phonePh: "请输入SIM卡的号码", // ph  placeholder
      flow: "分享流量",
      flowPh: "建议{flow}GB以下",
      flowPh1: "建议",
      flowPh2: "GB以下",
      shareEndTime: "分享日期至",
      shareEndTimePh: "分享结束日期",

      operator: "运营商",
      operatorPh: "选择运营商",
      pickerConfirmText: "确定",
      pickerCancelText: "取消",

      cancelBtn: "取消",
      submitBtn: "提交",

      needPhone: "请填写手机号",
      phoneError: "手机号填写错误",
      needFlow: "请填写分享流量额度",
      flowTip: "分享流量请输入{flow}以内的整数",
      flow1: "分享流量请输入",
      flow2: "以内的整数",
      flowCannot0: "分享流量不能为0",
      flowCannotMinus: "分享流量不能为负数",
      fillShareEndTime: "请填写分享截止时间",
      selectOperator: "请选择运营商"
    },

    oneSim: {
      dataError: "数据异常，",
      tryAgain: "刷新试试",
      loading: "加载中……",
      detectedSim: "检测到SIM卡",
      toShare: "去分享",
      detectedNoSim: "未检测到SIM卡",
      enterSim: "请插入SIM卡",
      status00: "等待分享",
      status01: "审核中",
      status02: "已配单，确认分享",
      status03: "审核失败,重新分享",
      status04: "正在分享",
      status05: "分享中断",
      status06: "重新分享",
      status07: "取消分享",
      status08: "卡业务状态异常"
    }
  },
  // 提现记录
  withdrawRecord: {
    title: "提现记录",
    totalProfit: "总收益",
    canWithdrawAmount: "可提现(元)",
    withdraw: "提现",
    withdrawRecord: "提现记录",
    withdrawAmount: "提现金额",
    moreRecord: "查看更多",
    noMoreData: "Sorry，没有新的数据哦",
    footer: "如有疑问，请联系公众号客服解决",
    cannotWithdraw: "您还未有分享的流量，赶紧去分享吧",
    noRecord: "您还没有提现记录哦~",
    contactMe: "请关注插卡宝公众号或者联系qq客服738605106"
  },
  // 提现
  withdraw: {
    title: "提现",
    canWithdrawAmountTip: "可提现金额(元)",
    withdrawPre: "￥",
    amountPh: "请输出要提现的金额",
    canWithdrawAmount: "可提现金额{amount}元",
    withdrawAll: "全部提现",
    withdrawTo: "提现到",
    wechatWallet: "微信钱包",
    sendMethod: "客服红包发放",
    nameConfirm: "身份核对：",
    namePh: "请输入您的真实姓名",
    withdrawBtn: "提现",
    tip: "客服给您打款的日期为每周五11:00~18:00（国家法定节假日除外）",
    footer: "如有疑问，请联系公众号客服解决",

    needName: "请输入您的真实姓名",
    withdrawTip: "客服已收到您的提现需求，我们将在周五给您打款。您可以加入以下QQ群寻求帮助{QQ}",
    alertButtonText: "确定",
    needAmount: "请填写提现金额",
    amountIsNaN: "提现金额只能输入数字",
    amountLg: "提现金额不可以大于可提现金额",
    twoDecimalPlaces: "最多支持两位小数",
    amountNegative: "提现金额不能为负数",
    amountIs0: "提现金额不能为0",
    usernameError: "姓名格式错误"
  },
  // 历史订单
  historyOrders: {
    title: "历史订单",
    createOrderTime: "订单时间",
    sharedFlow: "分享流量",
    moreOrder: "查看更多",
    noMoreData: "Sorry，没有新的数据哦",
    footer: "如有疑问，请联系公众号客服解决",
    noOrder: "您还未有完成订单哦，不要着急"
  },
  // 订单详情
  orderDetail: {
    title: "历史订单",
    phone: "手机号码",
    flow: "分享流量",
    createOrderTime: "订单时间",
    price: "价格规则",
    orderId: "订单单号",
    footer: "如有疑问，请联系公众号客服解决"
  },
  // 无设备
  noSim: {
    title: "卡分享详情",
    noCard: "还没有分享的流量卡哦~",
    toBind: "已有设备，去绑定",
    footer: "若无设备，请联系公众号客服"
  },
  // 设置
  setting: {
    title: "设置",
    device: "我的设备",
    language: "切换语言",
    logOut: "退出账号"
  },
  // 切换语言
  changeLanguage: {
    title: "切换语言"
  },
  // 隐私政策
  policy: {
    title: "隐私政策"
  },
  // 切换语言
  agreement: {
    title: "用户协议"
  },
  // 首页
  home: {
    title: "插卡宝",
    totalFit: "总收益金额",
    withdraw: "提现",
    withdrawHistory: "收益记录",
    historyOrder: "历史订单",
    instruction: "使用说明",
    myDevices: "我的设备",
    boxName: "SIM卡盒子",
    online: "在线",
    offline: "离线",
    imeiNum: "IMEI号",
    addDevice: "扫码添加设备",
    noDevice: "还没有绑定设备哦~",
    noFit: "暂无收益",
    noSignal: "无信号",
    profitUnit: "元",
    unknownPhone: "未识别您的机型",
    openInApp: "请在多卡宝APP中使用此功能"
  },
  reservationCode: {
    title: "插卡宝",
    inputCodeTip: "请输入您的预约码",
    noCode: "若您没有预约码请联系客服",
    codePlaceholder: "请输入您的预约码",
    btnText: "确定",
    auth: {
      tip: "确定即表示您已阅读并同意",
      agreeMent: "用户协议",
      and: "和",
      policy: "隐私政策"
    },
    validateSuccess: "验证成功"
  },
  instruction: {
    title: "使用说明",
    step1: "1、进入APP内，个人-SIM卡设置，选择“共享SIM卡”；",
    step1Remark: "(注：此时SIM卡将被设置为云卡，SIM卡设置为云卡后无法使用语音、短信等服务，在提交订单前可随时取消此状态。)",
    step2: "2、点击“立即申请”或在【个人】页面内点击“流量交易”，进入可提交订单；",
    step3: "3、【流量交易】内，可将此前所设置的SIM卡进行提交订单申请，待订单审核通过后可查看当前交易状态、金额等信息。",
    readBtn: "好的，知道了"
  },
  // 所有的过渡页面
  pages: {
    userCenter: "", // 个人中心
    myMachine: "我的设备"
  }
});
// CONCATENATED MODULE: ./src/lang/zh-TW.js
/**
 * Created by desheng.zhao on 2019/2/21.
 */

// 按页面划分
/* harmony default export */ var zh_TW = ({
  // 公共页面
  common: {
    fill: "請填寫",
    fillError: "填寫錯誤",
    fillHasError: "表單填寫不完整",
    ajaxError: "數據出錯了",
    networkError: "網絡出錯了~",
    tokenExpire: "登錄信息已失效或未登錄"
  },
  //邮箱登录
  emailLogin: {
    title: '登錄',
    subTitle: "郵箱登錄",
    emailAccount: "郵箱",
    password: "密碼",
    emailEmpty: "請填寫郵箱",
    emailError: "郵箱填寫錯誤",
    checkEmail: "請檢查郵箱"
  },
  // 登录
  login: {
    title: "登錄",
    subTitle: "手機登錄",
    phoneNo: "手機號",
    password: "密碼",
    msgCode: "驗證碼",
    getMsgCode: "獲取驗證碼",
    getMsgInterval: "s后可重新獲取", // 这里的s是秒的意思
    loginBtn: "登錄",
    registerBtn: "註冊",
    resetBtn: "忘記密碼",
    phoneEmpty: "請填寫手機會好",
    phoneError: "手機號填寫錯誤",
    checkPhone: "請檢查手機號",
    fillMsgCode: "請填寫手機驗證碼",
    fillPassword: "請填寫密碼",
    fill: "請填寫",
    fillError: "填寫錯誤",
    hasError: "表單填寫不完整或有誤",
    loginSuccess: "登錄成功",
    needMsgCheck: "本次登錄需要短信驗證碼驗證"
  },
  // 注册
  register: {
    title: "註冊",
    subTitle: "手機註冊",
    phoneNo: "手機號碼",
    password: "設置6-20位密碼",
    repeatPwd: "再次確認密碼",
    msgCode: "驗證碼",
    getMsgCode: "獲取驗證碼",
    getMsgInterval: "s后可重新獲取", // 这里的s是秒的意思
    picCode: "請輸入圖片驗證碼",
    getPicCode: "獲取圖片驗證碼",
    registerBtn: "註冊",
    auth: {
      tip: "註冊即表示您已閱讀并同意",
      agreeMent: "用戶協議",
      and: "和",
      policy: "隱私政策"
    },
    footer: "如有疑問，可在公眾號中反饋",

    phoneEmpty: "請填寫手機號",
    phoneError: "手機號填寫錯誤",
    fillPassword: "請填寫密碼",
    pwdInvalidLetter: "密碼中包含不合法的符號号",
    pwdLenLow: "密碼不可小於6位",
    pwdNeedLetter: "密碼需包含字母或特殊符號",
    pwdNeedNum: "密碼需包含數字",
    pwdLenUp: "密碼長度超過最大20位限制",
    fillRepeatPwd: "請填寫確認密碼",
    RepeatPwdError: "兩次密碼不一致致",
    fillMsgCode: "請填寫手機驗證碼",
    fillPicCode: "請填寫圖片驗證碼",
    getPicCodeFirst: "請先獲取圖片驗證碼",
    registSuccess: "註冊成功"
  },
  // 找回密码
  reset: { // 找回密码很多字段和注册一样，就直接调用注册的
    title: "重置密碼",
    subTitle: "重置密碼",
    resetBtn: "確認修改并登錄"
  },
  // 登录成功
  loginSuccess: {
    title: "登錄成功",
    logAccount: "賬號已登錄",
    toBindBtn: "去綁定設備",
    toShareBtn: "去分享流量",
    logOutBtn: "退出賬號",
    footer: "若無設備，請聯繫公眾號客服",

    isLogout: "是否要退出當前賬號？",
    confirmText: "確定",
    cancelText: "取消",
    logOutSuccess: "退出賬號成功"
  },
  // 绑定设备
  binding: {
    title: "綁定設備",
    imei: "設備編碼：",
    fillImei: "請輸入設備IMMEI號号",
    password: "設備密碼：",
    fillPwd: "請輸入設備密碼",
    bindBtn: "立即綁定",
    needImei: "請填寫設備編碼",
    needPwd: "請填寫設備密碼"
  },
  // 绑定设备成功
  binded: {
    title: "綁定成功",
    bindedMachine: "已綁定設備",
    toShare: "去分享卡流量",
    unbind: "解除綁定",
    unbindSuccess: "解除綁定成功",
    isUnbind: "是否要解除設備綁定？",
    confirmText: "確定",
    cancelText: "取消"
  },
  // 卡分享详情
  shareDetail: {
    title: "卡分享詳情",
    imei: "設備號",
    online: "在線",
    offline: "離線",
    tip: "溫馨提示",
    footer: "如有疑問，請聯繫公眾號客服解決",
    submitSuccessTip: "提交申請成功，客服將盡快給您審核派單，請您稍等一下，派單后需要您再次確認哦~",
    alertButtonText: "確定",
    offlineOperateTip: "設備離線狀態下不可以操作哦~",
    offlineTip: "您的設備已離線，請檢查設備狀態，離線將影響您的卡分享收益，如有疑問，請添加一下QQ群聯繫客服解決。",
    unbindedTip: "此設備已被解綁，請重新綁定",
    cancelSuccess: "取消成功",

    simShareInfo: { // sim-share-info
      simShareInfo: "卡分享信息",
      phone: "號碼",
      flow: "分享流量",
      price: "單價",
      shareEndTime: "分享日期至",
      cancelShareBtn: "取消分享",
      confirmShareBtn: "確認分享"
    },

    simShareSuccess: {
      shareSuccess: "分享成功",
      tip: "分享期間請保持設備的開啟狀態，保證穩定供卡",
      alertBtnText: "確定"
    },

    submitSimInfo: {
      title: "填寫分享卡的套餐信息",
      phone: "號碼",
      phonePh: "請輸入SIM卡的號碼", // ph  placeholder
      flow: "分享流量",
      flowPh: "建議{flow}GB以下",
      flowPh1: "建議",
      flowPh2: "GB以下",
      shareEndTime: "分享日期至",
      shareEndTimePh: "分享結束日期",

      operator: "運營商",
      operatorPh: "選擇運營商",
      pickerConfirmText: "確定",
      pickerCancelText: "取消",

      cancelBtn: "取消",
      submitBtn: "提交",

      needPhone: "請填寫手機號",
      phoneError: "手機號填寫錯誤",
      needFlow: "請填寫分享流量額度",
      flowTip: "分享流量請輸入{flow}以內的整數",
      flow1: "分享流量請輸入",
      flow2: "以内的整數",
      flowCannot0: "分享流量不能為0",
      flowCannotMinus: "分享流量不能為負數",
      fillShareEndTime: "請填寫分享截止時間",
      selectOperator: "請選擇運營商"
    },

    oneSim: {
      dataError: "數據異常，",
      tryAgain: "刷新試試",
      loading: "加載中……",
      detectedSim: "檢測到SIM卡",
      toShare: "去分享",
      detectedNoSim: "未檢測到SIM卡",
      enterSim: "請插入SIM卡",
      status00: "等待分享",
      status01: "審核中",
      status02: "已配單，確認分享",
      status03: "審核失敗,重新分享",
      status04: "正在分享",
      status05: "分享中斷",
      status06: "重新分享",
      status07: "取消分享",
      status08: "卡業務狀態異常"
    }
  },
  // 提现记录
  withdrawRecord: {
    title: "提現記錄",
    totalProfit: "總收益",
    canWithdrawAmount: "可提現(元)",
    withdraw: "提現",
    withdrawRecord: "提現記錄",
    withdrawAmount: "提現金額",
    moreRecord: "查看更多",
    noMoreData: "Sorry，沒有新的數據哦",
    footer: "如有疑問，請聯繫公眾號客服解決",
    cannotWithdraw: "您還未有分享的流量，趕緊去分享吧",
    noRecord: "您還沒有提現記錄哦~",
    contactMe: "請關注插卡寶公眾號或者聯繫qq客服738605106"
  },
  // 提现
  withdraw: {
    title: "提現",
    canWithdrawAmountTip: "可提現金額(元)",
    withdrawPre: "￥",
    amountPh: "請輸入要提現的金額",
    canWithdrawAmount: "可提現金額{amount}元",
    withdrawAll: "全部提現",
    withdrawTo: "提現到",
    wechatWallet: "微信錢包",
    sendMethod: "客服紅包發放",
    nameConfirm: "身份核對：",
    namePh: "請輸入您的真實姓名名",
    withdrawBtn: "提現",
    tip: "客服給您打款的日期為每週五11:00~18:00（國家法定節假日除外）",
    footer: "如有疑問，請聯繫公眾號客服解決",

    needName: "請輸入您的真實姓名",
    withdrawTip: "客服已收到您的提現需求，我們將在週五給您打款。您可以加入以下QQ群尋求幫助{QQ}",
    alertButtonText: "確定",
    needAmount: "請填寫提現金額",
    amountIsNaN: "提現金額只能輸入數字字",
    amountLg: "提現金額不可以大於可提現金額",
    twoDecimalPlaces: "最多支持兩位小數数",
    amountNegative: "提現金額不能為負數",
    amountIs0: "提現金額不能為0",
    usernameError: "姓名格式錯誤"
  },
  // 历史订单
  historyOrders: {
    title: "歷史訂單",
    createOrderTime: "訂單時間",
    sharedFlow: "分享流量",
    moreOrder: "查看更多",
    noMoreData: "Sorry，沒有新的數據哦",
    footer: "如有疑問，請聯繫公眾號客服解决",
    noOrder: "您還未有完成訂單哦，不要著急"
  },
  // 订单详情
  orderDetail: {
    title: "歷史訂單",
    phone: "手機號碼",
    flow: "分享流量",
    createOrderTime: "訂單時間",
    price: "價格規則",
    orderId: "訂單單號",
    footer: "如有疑問，請聯繫公眾號客服解决"
  },
  // 无设备
  noSim: {
    title: "卡分享詳情",
    noCard: "還沒有分享的流量卡哦~",
    toBind: "已有設備，去綁定",
    footer: "若無設備，請聯繫公眾號客服"
  },
  // 设置
  setting: {
    title: "設置",
    device: "我的設備",
    language: "切換語言",
    logOut: "退出賬號"
  },
  // 切换语言
  changeLanguage: {
    title: "切換語言"
  },
  // 隐私政策
  policy: {
    title: "隱私政策"
  },
  // 切换语言
  agreement: {
    title: "用戶協議"
  },
  // 首页
  home: {
    title: "插卡寶",
    totalFit: "總收益金額",
    withdraw: "提現",
    withdrawHistory: "收益記錄",
    historyOrder: "歷史訂單",
    instruction: "使用說明",
    myDevices: "我的設備",
    boxName: "SIM卡盒子",
    online: "在線",
    offline: "離線",
    imeiNum: "IMEI號",
    addDevice: "掃碼添加設備",
    noDevice: "還沒有綁定設備哦~",
    noFit: "暫無收益",
    noSignal: "無信號",
    profitUnit: "元",
    unknownPhone: "未識別您的機型",
    openInApp: "請在多卡寳APP中使用此功能"
  },
  reservationCode: {
    title: "插卡寶",
    inputCodeTip: "請輸入您的預約碼",
    noCode: "若您沒有預約碼請聯繫客服",
    codePlaceholder: "請輸入您的預約碼",
    btnText: "確定",
    auth: {
      tip: "確定即表示您已閱讀并同意",
      agreeMent: "用戶協議",
      and: "和",
      policy: "隱私政策"
    },
    validateSuccess: "驗證成功"
  },
  // 使用说明
  instruction: {
    title: "使用說明",
    step1: "1、進入APP內，個人-SIM卡設置，選擇“共享SIM卡”；",
    step1Remark: "(注：此時SIM卡將被設置為雲卡，SIM卡設置為雲卡后無法使用語音、短息等服務，在提交訂單前可隨時取消此狀態。)",
    step2: "2、點擊“立即申請”或在【個人】頁面內點擊“流量交易”，進入可提交訂單；",
    step3: "3、【流量交易】內，可將此前所設置的SIM卡進行提交訂單申請，待訂單審核通過后可查看此前交易狀態、金額等信息。",
    readBtn: "好的，知道了"
  },
  // 所有的过渡页面
  pages: {
    userCenter: "個人中心",
    myMachine: "我的設備"
  }
});
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/lang/index.js
/**
 * Created by desheng.zhao on 2019/2/21.
 */







vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);

var messages = {
  "zh-CN": zh,
  "en-US": en,
  "zh-TW": zh_TW
};
var dateFormate = {
  "zh-CN": {
    short: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
    }
  },
  "en-US": {
    short: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  }
};
var defaultLanguage = "zh-CN";
// var localLang = localStorage.getItem("language");
var localLang = cookie["a" /* default */].get("lang");
var language = localLang || defaultLanguage;
var lang_lang;
switch (language) {
  case "zh-CN":
    lang_lang = "zh-CN";
    break;
  case "en-US":
    lang_lang = "en-US";
    break;
  case "zh-TW":
    lang_lang = "zh-TW";
    break;
  default:
    lang_lang = "zh-CN";
}
// var lang = language == "zh" ? "zh-CN" : "en-US";
cookie["a" /* default */].set("lang", lang_lang, { expires: 365, path: '/' });
// !localLang && localStorage.setItem("language", language);
// !localLang && cookie.set("lang", language);

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: language,
  messages: messages,
  dateTimeFormats: dateFormate, //日期格式化$d
  fallbackLocale: "zh-CN"
});

/* harmony default export */ var src_lang = (i18n);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/md5/index.js
var md5 = __webpack_require__("SWtL");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/base64/index.js
var base64 = __webpack_require__("N/hF");
var base64_default = /*#__PURE__*/__webpack_require__.n(base64);

// EXTERNAL MODULE: ./src/utils/location.js
var utils_location = __webpack_require__("BtWE");

// CONCATENATED MODULE: ./src/utils/ajax.js






var login = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
    var phone, password, origin;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            phone = localStorage.getItem("c");

            if (!(phone == 'undefined')) {
              _context.next = 4;
              break;
            }

            goToLogin();
            return _context.abrupt('return');

          case 4:
            password = localStorage.getItem("p");

            if (password) {
              password = base64_default.a.decode(password);
            }

            if (!(phone && password)) {
              _context.next = 12;
              break;
            }

            origin = location.origin || window.location.origin;
            _context.next = 10;
            return axios_default.a.post(origin + src_config_config.api.login, {
              userCode: phone,
              password: Object(md5["a" /* default */])(password),
              streamNo: 'web_pss' + new Date().getTime() + parseInt(Math.random() * 1000000)
            }).then(function (res) {

              if (res.data.resultCode == "00000000") {
                vm.$saveData(res.data.data, phone, password);

                var url = (location.origin || window.location.origin) + router.currentRoute.fullPath;
                Object(utils_location["a" /* default */])(url);
              } else {
                goToLogin();
              }
            }).catch(function (err) {
              ajax_addError(err);
              goToLogin();
              console.log(err);
            }).finally(function () {
              timer = null;
            });

          case 10:
            _context.next = 13;
            break;

          case 12:
            goToLogin();

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function login() {
    return _ref.apply(this, arguments);
  };
}();

/**
* Created by desheng.zhao on 2018/6/19.
*/












var vm = new vue_esm["a" /* default */]();

var requestQueue = [];

/*使用自定义配置新建一个axios*/
var service = axios_default.a.create({
  timeout: 60 * 1000
});

var timer = null;

service.interceptors.request.use(function (config) {
  if (!config.noLoading) {
    requestQueue.push(config.url);
  }

  var userCode = cookie["a" /* default */].get(src_config_config.userCode);
  var lang = cookie["a" /* default */].get("lang") || "zh-CN";

  if (typeof userCode == 'string') {
    //兼容用户名为邮箱
    if (!userCode.includes('@')) {
      if (userCode.length > 11) {
        userCode = userCode.slice(-11);
      }
    }
  }
  var authParams = {
    userId: cookie["a" /* default */].get(src_config_config.userId),
    userCode: userCode,
    accessToken: cookie["a" /* default */].get(src_config_config.tokenId)
  };
  var commonParam = {
    streamNo: 'web_pss' + new Date().getTime() + parseInt(Math.random() * 1000000),
    lang: lang
  };
  config.data = extends_default()({}, config.data, commonParam);
  if (config.method.toLowerCase() === 'get') {
    if (!config.noAuth) {
      //不需要权限的不加权限信息
      config.params = extends_default()({}, config.data, authParams);
    }
    config.params && keys_default()(config.params).forEach(function (val) {
      if (config.params[val] === '' || config.params[val] === undefined || config.params[val] === null) {
        delete config.params[val];
      }
    });
    delete config.data;
  } else {
    if (!config.noAuth) {
      //不需要权限的不加权限信息
      config.data = extends_default()({}, config.data, authParams);
    }
    config.data && keys_default()(config.data).forEach(function (val) {
      if (config.data[val] === '' || config.data[val] === undefined || config.data[val] === null) {
        delete config.data[val];
      }
    });
  }

  if (requestQueue.length > 0) {
    vue_esm["a" /* default */].$vux.loading.show({
      text: '加载中'
    });
  }
  return config;
}, function (error) {
  console.log(error);
  ajax_addError(error);
  promise_default.a.reject(error);
});

service.interceptors.response.use(function (response) {
  hideLoading(response.config.url);

  var loginError = ['99999996', '99999995', '99999994', '99999993', '99999992', '20000001', "00000001", "00000002", "00000003", "00000004", "00000005", "00000006", "00000007", "00000008"]; // 登录信息异常的状态码
  if (response.data && loginError.includes(response.data.resultCode)) {

    if (!timer) {
      timer = true;
      var userAgent = window.navigator.userAgent;
      if (/glocalMeCall/i.test(userAgent)) {
        appLogin();
      } else {
        login();
      }
    }
  } else {
    if (response.data.resultCode === "00000000") {
      return response.data;
    }

    return response.data;
  }
}, function (error) {

  hideLoading(error.config.url);
  ajax_addError(error);

  vue_esm["a" /* default */].$vux.toast.show({
    type: "text",
    text: src_lang.t("common.networkError"), // "网络出错啦~",
    position: "bottom"
  });
  return promise_default.a.reject(error);
});

function hideLoading(url) {
  var index = requestQueue.indexOf(url);
  index != -1 && requestQueue.splice(index, 1);
  if (requestQueue.length === 0) {
    vue_esm["a" /* default */].$vux.loading.hide();
  }
}

function goToLogin() {
  vue_esm["a" /* default */].$vux.toast.show({
    type: 'text',
    text: src_lang.t("common.tokenExpire"), //'登录信息已失效或未登录',
    time: 2000,
    position: 'bottom',
    onHide: function onHide() {
      vm.$removeData();
      router.push({
        name: "login",
        query: {
          redirectUrl: router.currentRoute.name
        }
      });
    }
  });
}

function systemType() {
  var u = window.navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isAndroid) {
    return "Android";
  }
  if (isIOS) {
    return "ios";
  }
  return "未知";
}

/*
* 在app內登錄信息過期重新登錄
* */
function appLogin() {
  var system = systemType();

  if (system == 'Android') {
    try {
      JsBridge.expireToRelogin();
    } catch (err) {
      vue_esm["a" /* default */].$vux.toast.text(err.name + ":\n" + err.message, "bottom");
      ajax_addError(err);
    }
  } else if (system == 'ios') {
    try {
      window.webkit.messageHandlers.expireToRelogin.postMessage({ methodName: "expireToRelogin" });
    } catch (err) {
      vue_esm["a" /* default */].$vux.toast.text(err.name + ":\n" + err.message, "bottom");
      ajax_addError(err);
    }
  } else {
    login();
  }
}

function ajax_addError(err) {
  src_store.dispatch("addError", {
    page: "ajax util",
    error: err
  });
}

/* harmony default export */ var ajax = (service);
// CONCATENATED MODULE: ./src/plugins/globalFn.js




var _this3 = this;

/**
* Created by xing.lin on 2019/6/11.
*/








function loginSaveData(data, phone, password) {

  this.$cookie.set(this.$config.userId, data.userId);
  this.$cookie.set(this.$config.tokenId, data.accessToken);
  this.$cookie.set(this.$config.userCode, data.userCode);
  this.$cookie.set("loginTime", new Date().getTime());
  var phone = data.userCode && data.userCode.replace(/^86/, "");
  localStorage.setItem("userCode", phone);

  if (phone && password) {
    localStorage.setItem("c", phone);
    localStorage.setItem("p", base64_default.a.encode(password));
  }
}

function logoutRemoveData(removeCP) {
  // removeCP 是否删除账户和密码
  this.$cookie.remove(this.$config.userCode);
  this.$cookie.remove(this.$config.userId);
  this.$cookie.remove(this.$config.tokenId);
  this.$cookie.remove('c');
  this.$cookie.remove('p');
  this.$cookie.remove("loginTime");
  sessionStorage.clear();
  localStorage.removeItem("userCode");
  localStorage.removeItem("userName");
  localStorage.removeItem("imei");
  localStorage.removeItem("isAuthed");
  if (removeCP) {
    removeAccount();
  }
}

function removeAccount() {
  localStorage.removeItem("c");
  localStorage.removeItem("p");
}

function globalFn_login(userCode, password) {
  var _this = this;

  console.log("main.js中的登录");
  this.$ajax({
    url: this.$api.login,
    method: 'post',
    noAuth: true,
    data: {
      userCode: userCode,
      password: Object(md5["a" /* default */])(password)
    }
  }).then(function (res) {
    if (res.resultCode == "00000000") {

      _this.$saveData(res.data, userCode, password);
      var redirectUrl = _this.$route.query.redirectUrl;
      if (redirectUrl) {
        _this.$router.replace({
          name: redirectUrl
        });
      } else {
        _this.$router.replace({
          name: "home"
        });
      }
    } else {
      _this.$router.push({
        name: "login"
      });
    }
  }).catch(function (err) {
    console.log(err);
  });
}

function toast(text) {
  var _this2 = this;

  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  vue_esm["a" /* default */].$vux.toast.show({
    type: "text",
    text: text,
    time: time,
    position: "bottom",
    onHide: function onHide() {
      cb && cb.call(_this2);
    }
  });
}

var isAuthed = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
    var authMsg, userId, res;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            authMsg = JSON.parse(localStorage.getItem("authMsg") || "[]");
            userId = cookie["a" /* default */].getCookie(src_config_config.userId);

            if (!authMsg.includes(userId)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt('return', true);

          case 7:
            _context.next = 9;
            return ajax({
              url: src_config_config.api.checkUserCode,
              method: 'post',
              data: {}
            });

          case 9:
            res = _context.sent;

            if (!(res.resultCode == "00000000")) {
              _context.next = 20;
              break;
            }

            if (!(res.data && res.data.is_reservation_user)) {
              _context.next = 17;
              break;
            }

            authMsg.push(userId);
            localStorage.setItem("authMsg", stringify_default()(authMsg));
            return _context.abrupt('return', true);

          case 17:
            return _context.abrupt('return', false);

          case 18:
            _context.next = 22;
            break;

          case 20:
            _this3.$toast("查询预约码出错了");
            return _context.abrupt('return', false);

          case 22:
            _context.next = 29;
            break;

          case 24:
            _context.prev = 24;
            _context.t0 = _context['catch'](0);

            _this3.$toast("程序抛锚了");
            localStorage.removeItem("authMsg");
            console.log(_context.t0);

          case 29:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this3, [[0, 24]]);
  }));

  return function isAuthed() {
    return _ref.apply(this, arguments);
  };
}();

function trackPageView(to) {
  // 统计页面曝光
  var _czc = window._czc || [];
  if (to.path) {

    _czc.push(['_trackPageview', to.path]);
  }
}

/* harmony default export */ var globalFn = ({
  install: function install(Vue, options) {
    Vue.prototype.$api = src_config_config.api;
    Vue.prototype.$cookie = cookie["a" /* default */];
    Vue.prototype.$config = src_config_config;
    Vue.prototype.$ajax = ajax;

    Vue.prototype.$saveData = loginSaveData;
    Vue.prototype.$removeData = logoutRemoveData;
    Vue.prototype.$login = globalFn_login;
    Vue.prototype.$dispatchTouchmove = dispatchTouchmove;

    Vue.prototype.$toast = toast;
  }
});
// EXTERNAL MODULE: ./src/filters/date.js
var date = __webpack_require__("5TPd");
var date_default = /*#__PURE__*/__webpack_require__.n(date);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./src/filters/filters.js

/**
 * Created by han.xie on 2018/3/19.
 */

// 转换时间long格式到yyyy/mm/dd
var getDayFormatTime = function getDayFormatTime(timestamp) {
    var date = new Date(timestamp);
    if (String(timestamp).length === 10) {
        date = new Date(timestamp * 1000);
    }
    var Y = date.getFullYear() + '/';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
    var D = date.getDate();
    return Y + M + D;
};

//转换时间long格式到yyyy-mm-dd HH:MM:SS
var getFormatTime = function getFormatTime(timestamp) {
    var date = new Date(timestamp);
    if (String(timestamp).length === 10) {
        date = new Date(timestamp * 1000);
    }
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate();
    var HH = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var MM = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var SS = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + " " + HH + MM + SS;
};

// 1200 | decimal("￥") => ￥ 12.00
var filters_decimal = function decimal(num, symbol) {
    var type = typeof num === 'undefined' ? 'undefined' : typeof_default()(num);
    if (symbol === undefined) symbol = "";
    if (type !== "number" && type !== "string") return num;
    return symbol + (Number(num) / 100).toFixed(2);
};

// 隐藏手机号中间四位
var hidePhoneNum = function hidePhoneNum(phone) {
    if (String(phone).length === 11) {
        return String(phone).substr(0, 3) + "****" + String(phone).substr(7);
    } else {
        return String(phone);
    }
};


// CONCATENATED MODULE: ./src/filters/tel.js
/**
 * Created by desheng.zhao on 2018/12/3.
 */
var tel = function tel(_tel) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";

  if (_tel && _tel.length == 11) {
    return [_tel.slice(0, 3), _tel.slice(3, 7), _tel.slice(7, 11)].join(sep);
  } else {
    return _tel;
  }
};
/* harmony default export */ var filters_tel = (tel);
// CONCATENATED MODULE: ./src/filters/BtoG.js
/**
 * Created by desheng.zhao on 2018/12/6.
 */
function b2g(byte) {
  if (typeof byte == "number" || Number(byte)) {
    return (Number(byte) / Math.pow(1024, 3)).toFixed(2);
  } else {
    console.warn("未知(流量)类型不可以转换");
    return byte;
  }
}

/* harmony default export */ var BtoG = (b2g);
// CONCATENATED MODULE: ./src/filters/index.js

/**
 * Created by desheng.zhao on 2018/11/30.
 */





// 全局过滤器
var global = extends_default()({}, date, filters_namespaceObject, {
  tel: filters_tel,
  b2g: BtoG

  // 局部过滤器
});var local = extends_default()({}, date, filters_namespaceObject);
// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var node_modules_object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(node_modules_object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb223dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){_vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key)){ return null; }},function($event){_vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("qPUl")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var components_toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && typeof this.currentValue === 'undefined') {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: components_toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      this.$emit('on-focus', this.currentValue, $event);
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    }
  },
  data: function data() {
    var data = {
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false
    };
    return data;
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal) {
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      this.$emit('input', this.maskValue(newVal));
      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && typeof this.currentValue === 'undefined') {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: components_toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      this.$emit('on-focus', this.currentValue, $event);
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    }
  },
  data: function data() {
    var data = {
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false
    };
    return data;
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal) {
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      this.$emit('input', this.maskValue(newVal));
      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68cd1be1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{'weui-cell_warn': _vm.showWarn, 'disabled': _vm.disabled}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.equalWith && _vm.showClear && _vm.currentValue && !_vm.readonly && !_vm.disabled),expression:"!equalWith && showClear && currentValue && !readonly && !disabled"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){_vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){_vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){_vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("b2Oo")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var libs_router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f075ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("+1ys")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/index.vue + 3 modules
var cell = __webpack_require__("1DHf");

// EXTERNAL MODULE: ./node_modules/vux/src/components/alert/index.vue + 3 modules
var components_alert = __webpack_require__("mzja");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/topTip.vue


/* harmony default export */ var topTip = ({
  props: {
    time: {
      type: Number,
      default: 2000
    },
    errMsg: {
      type: String,
      required: true
    },
    value: {
      required: true,
      type: Boolean
    },
    autoClose: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      timer: null
    };
  },

  methods: {
    close: function close() {
      clearTimeout(this.timer);
      this.$emit("input", false);
    }
  },
  updated: function updated() {
    var _this = this;

    if (this.value && this.autoClose) {
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.$emit("input", false);
      }, this.time);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/topTip.vue


/* harmony default export */ var components_topTip = ({
  props: {
    time: {
      type: Number,
      default: 2000
    },
    errMsg: {
      type: String,
      required: true
    },
    value: {
      required: true,
      type: Boolean
    },
    autoClose: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      timer: null
    };
  },

  methods: {
    close: function close() {
      clearTimeout(this.timer);
      this.$emit("input", false);
    }
  },
  updated: function updated() {
    var _this = this;

    if (this.value && this.autoClose) {
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.$emit("input", false);
      }, this.time);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ff3066","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topTip.vue
var topTip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"top-tip"},[_c('span',{staticClass:"err-info"},[_vm._t("default",[_vm._v(_vm._s(_vm.errMsg))])],2),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-close-empty close-icon",attrs:{"type":"ios-close-empty","size":"32","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 512 512"},on:{"click":_vm.close}},[_c('path',{staticClass:"st0",attrs:{"d":"M340.2 160l-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z"}})])])}
var topTip_staticRenderFns = []
var topTip_esExports = { render: topTip_render, staticRenderFns: topTip_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_topTip = (topTip_esExports);
// CONCATENATED MODULE: ./src/components/topTip.vue
function topTip_injectStyle (ssrContext) {
  __webpack_require__("ZkUb")
}
var topTip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var topTip___vue_template_functional__ = false
/* styles */
var topTip___vue_styles__ = topTip_injectStyle
/* scopeId */
var topTip___vue_scopeId__ = "data-v-22ff3066"
/* moduleIdentifier (server only) */
var topTip___vue_module_identifier__ = null
var topTip_Component = topTip_normalizeComponent(
  components_topTip,
  selectortype_template_index_0_src_components_topTip,
  topTip___vue_template_functional__,
  topTip___vue_styles__,
  topTip___vue_scopeId__,
  topTip___vue_module_identifier__
)

/* harmony default export */ var src_components_topTip = (topTip_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/footer.vue
//
//
//
//

/* harmony default export */ var footer = ({
  data: function data() {
    return {
      content: this.$t('withdrawRecord.footer')
    };
  },

  methods: {
    connect: function connect() {
      this.contactMe();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/footer.vue
//
//
//
//

/* harmony default export */ var components_footer = ({
  data: function data() {
    return {
      content: this.$t('withdrawRecord.footer')
    };
  },

  methods: {
    connect: function connect() {
      this.contactMe();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694d089e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"footer-info",on:{"click":_vm.connect}},[_vm._v(_vm._s(_vm.content))])}
var footer_staticRenderFns = []
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_footer = (footer_esExports);
// CONCATENATED MODULE: ./src/components/footer.vue
function footer_injectStyle (ssrContext) {
  __webpack_require__("PNAy")
}
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = footer_injectStyle
/* scopeId */
var footer___vue_scopeId__ = "data-v-694d089e"
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  components_footer,
  selectortype_template_index_0_src_components_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var src_components_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./src/components/index.js
/**
* Created by desheng.zhao on 2018/12/3.
*/










var components_global = {
  XHeader: vux_src_components_x_header, XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Group: group["a" /* default */], Cell: cell["a" /* default */], Alert: components_alert["a" /* default */], topTip: src_components_topTip, conFooter: src_components_footer
};

var components_local = {};
// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");
var transfer_dom_default = /*#__PURE__*/__webpack_require__.n(transfer_dom);

// CONCATENATED MODULE: ./src/directives/num-format.js
/* harmony default export */ var num_format = ({
	four: { //4-4-4-4-4
		update: function update(el, binding) {
			if (binding.value.length != 1) {
				return;
			}
			var val = el.value || el.innerText;
			//每次输入的时候先把分隔符去掉
			var reg = new RegExp(binding.value, 'g');
			val = val.replace(reg, "");
			var arr = val.split("");

			var format = "";
			for (var i = 0; i < arr.length; i++) {
				if (i % 4 == 0 && i != 0) {
					format += binding.value;
				}
				format += arr[i];
			}
			el.value = format;
			// el.innerText = format;
		}
	},
	txt: {
		inserted: function inserted(el, binding) {
			if (binding.value.length != 1) {
				return;
			}
			var val = el.innerText;
			console.log(val);
			//每次输入的时候先把分隔符去掉
			var reg = new RegExp(binding.value, 'g');
			val = val.replace(reg, "");
			var arr = val.split("");

			var format = "";
			for (var i = 0; i < arr.length; i++) {
				if (i % 4 == 0 && i != 0) {
					format += binding.value;
				}
				format += arr[i];
			}
			el.innerText = format;
		}
	},
	tel: { //手机号3-4-4
		update: function update(el, binding) {
			if (binding.value.length != 1) {
				return;
			}
			var val = el.value;
			//每次输入的时候先把分隔符去掉
			var reg = new RegExp(binding.value, 'g');
			val = val.replace(reg, "");
			var arr = val.split("");

			for (var i = 0; i < arr.length; i++) {
				if (i == 3) {
					arr.splice(3, 0, binding.value);
				} else if (i == 3 + 1 + 4) {
					arr.splice(3 + 1 + 4, 0, binding.value);
				}
			}
			el.value = arr.join("");
		}
	},
	iosbug: {
		inserted: function inserted(el, binding) {
			el.onblur = function () {
				setTimeout(function () {
					document.dispatchEvent(new Event('touchmove'));
					var doc = document.body || document.documentElement;
					var scrollTop = doc.scrollTop;
					doc.scrollTop = scrollTop + 10;
					setTimeout(function () {
						doc.scrollTop = scrollTop;
						console.log(121);
					}, 30);
				}, 100);
			};
		}
	}
});
// CONCATENATED MODULE: ./src/directives/index.js

/**
* Created by desheng.zhao on 2018/11/30.
*/




var directives_global = extends_default()({
  TransferDom: transfer_dom_default.a
}, num_format);

var directives_local = extends_default()({
  TransferDom: transfer_dom_default.a
}, num_format);
// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var plugins_toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/datetime/index.js
var datetime = __webpack_require__("oVYx");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// CONCATENATED MODULE: ./src/plugins/index.js
/**
* Created by desheng.zhao on 2018/11/30.
*/








var plugins_global = {
  LoadingPlugin: loading["a" /* default */],
  AlertPlugin: plugins_alert["a" /* default */],
  ToastPlugin: plugins_toast["a" /* default */],
  DatetimePlugin: datetime["a" /* default */],
  ConfirmPlugin: plugins_confirm["a" /* default */],
  globalFn: globalFn
};
// EXTERNAL MODULE: ./src/mixin/index.js + 4 modules
var src_mixin = __webpack_require__("is1l");

// CONCATENATED MODULE: ./src/plugins/globalRegist.js

/**
 * Created by xing.lin on 2019/6/11.
 */






/* harmony default export */ var globalRegist = ({
    install: function install(Vue) {
        // 全局注册插件
        keys_default()(plugins_global).forEach(function (key) {
            Vue.use(plugins_global[key]);
        });

        // 全局注册组件
        keys_default()(components_global).forEach(function (key) {
            Vue.component(key, components_global[key]);
        });

        // 全局注册过滤器
        keys_default()(global).forEach(function (key) {
            Vue.filter(key, global[key]);
        });

        // 全局注册指令
        keys_default()(directives_global).forEach(function (key) {
            Vue.directive(key, directives_global[key]);
        });

        // 全局注册mixin
        keys_default()(src_mixin["a" /* global */]).forEach(function (mixin) {
            Vue.mixin(src_mixin["a" /* global */][mixin]);
        });
    }
});
// CONCATENATED MODULE: ./src/main.js




var main__this = this;













vue_esm["a" /* default */].use(globalRegist);

app_config.getConfig().then(function (d) {
    assign_default()(src_config_config, d);

    var cookie_expires = src_config_config.cookie_expires;

    cookie["a" /* default */].setDefaults({ expires: cookie_expires, path: '/' });

    vue_esm["a" /* default */].config.productionTip = false;

    router.beforeEach(function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(to, from, next) {
            var hasSeenInstruction, auth;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // 程序首次打开的时候会有一个使用说明的指导，以后不显示
                            if (to.name !== 'instruction') {
                                // 一定要排除这个页面的判断，负责会死循环
                                hasSeenInstruction = localStorage.getItem("hasSeenInstruction");

                                if (hasSeenInstruction !== "true") {
                                    next(false);
                                    router.push({
                                        name: 'instruction'
                                    });
                                }
                            }

                            // 登录cookie验证

                            if (!(to.meta && to.meta.requireAuth)) {
                                _context.next = 12;
                                break;
                            }

                            if (!(!cookie["a" /* default */].getCookie(src_config_config.tokenId) || !cookie["a" /* default */].getCookie(src_config_config.userId) || !cookie["a" /* default */].getCookie(src_config_config.userCode))) {
                                _context.next = 7;
                                break;
                            }

                            next(false);
                            router.push({
                                name: 'login',
                                query: {
                                    redirectUrl: to.name
                                }
                            });
                            _context.next = 12;
                            break;

                        case 7:
                            if (!(to.name != "reservationCode")) {
                                _context.next = 12;
                                break;
                            }

                            _context.next = 10;
                            return isAuthed();

                        case 10:
                            auth = _context.sent;

                            if (!auth) {
                                next(false);
                                router.push({
                                    name: 'reservationCode'
                                });
                            }

                        case 12:

                            next();

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, main__this);
        }));

        return function (_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        };
    }());
    router.afterEach(function (to, from) {
        try {
            trackPageView(to); // 统计页面曝光
        } catch (err) {
            console.log(err);
        }

        var title = document.getElementsByTagName("title")[0];
        if (to.meta && to.meta.title) {
            title.innerHTML = src_lang.t(to.meta.title);
        }
    });
    /* eslint-disable no-new */

    new vue_esm["a" /* default */]({
        store: src_store,
        i18n: src_lang,
        router: router,
        render: function render(h) {
            return h(src_App);
        }
    }).$mount('#app-box');
}, function (err) {});

/***/ }),

/***/ "PNAy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UNGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 2 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");
var format_default = /*#__PURE__*/__webpack_require__.n(date_format);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            _this.$emit('on-confirm');
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = format_default()(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            _this.$emit('on-confirm');
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = format_default()(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f53b7c40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:({
          width: _vm.$parent.labelWidth,
          textAlign: _vm.$parent.labelAlign,
          marginRight: _vm.$parent.labelMarginRight
        }),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({textAlign: _vm.valueTextAlign})},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var staticRenderFns = []
var esExports = { render: datetime_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_datetime = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("V52n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_datetime,
  src_components_datetime,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V52n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VASZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZdaW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZkUb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b2Oo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iPXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cookie; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);





/**
 * Created by dingkang.li on 2018/2/28.
 */


var Cookie = function (_Cookies) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Cookie, _Cookies);

  function Cookie() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Cookie);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Cookie.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Cookie)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Cookie, null, [{
    key: 'setDefaults',
    value: function setDefaults(defaults) {
      __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.defaults = defaults;
    }
  }, {
    key: 'getAllCookie',
    value: function getAllCookie() {
      return this.get();
    }
  }, {
    key: 'clearAllCookie',
    value: function clearAllCookie() {
      var cookies = this.get();
      for (var i in cookies) {
        this.remove(i);
      }
    }
  }, {
    key: 'setCookies',
    value: function setCookies(arr) {
      var _this2 = this;

      arr.forEach(function (v, i) {
        _this2.set(v['key'], v['value'], { expires: v['expires'], path: v['path'] });
      });
    }
  }]);

  return Cookie;
}(__WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a);

Cookie.getCookie = Cookie.get;
Cookie.setCookie = Cookie.set;
Cookie.clearCookie = Cookie.remove;



/***/ }),

/***/ "is1l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/mixin/error.js

/**
 * Created by desheng.zhao on 2019/6/17.
 */

/* harmony default export */ var error = ({
  methods: extends_default()({
    pushError: function pushError(err) {
      this.addError({
        page: this.$t(this.$router.currentRoute.meta.title),
        error: err
      });
    }
  }, Object(vuex_esm["b" /* mapActions */])(["addError"]))
});
// CONCATENATED MODULE: ./src/mixin/info.js

/**
 * Created by desheng.zhao on 2019/6/17.
 */

/* harmony default export */ var info = ({
  methods: extends_default()({
    pushInfo: function pushInfo(info) {
      this.addInfo({
        page: this.$t(this.$router.currentRoute.meta.title),
        info: info
      });
    }
  }, Object(vuex_esm["b" /* mapActions */])(["addInfo"]))
});
// CONCATENATED MODULE: ./src/mixin/formValidate.js
/**
 * Created by xing.lin on 2019/6/20.
 */
/* harmony default export */ var formValidate = ({
    data: function data() {
        return {
            errmsg: '',
            canSubmit: false
        };
    },

    methods: {
        check: function check(val, validates) {
            var errmsg = "";
            for (var i = 0; i < validates.length; i++) {
                if (validates[i].required) {
                    if (val === "" || val === undefined || val === null) {
                        errmsg = validates[i].errmsg || this.$t('common.fill');
                        break;
                    }
                } else if (typeof validates[i].rule == "function") {
                    if (!validates[i].rule(val)) {
                        errmsg = validates[i].errmsg || this.$t('common.fillError');
                        break;
                    }
                } else if (Object.prototype.toString.call(validates[i].rule) == "[object RegExp]") {
                    if (!validates[i].rule.test(val)) {
                        errmsg = validates[i].errmsg || this.$t('common.fillError');
                        break;
                    }
                }
            }
            return errmsg ? errmsg : true;
        },
        checkParams: function checkParams(arr) {
            for (var i = 0, len = arr.length; i < len; i++) {
                this.canSubmit = false;
                this.errmsg = "";
                var res = this.check(arr[i].value, arr[i].rules);
                if (res === true) {
                    this.canSubmit = true;
                } else {
                    this.errmsg = res;
                    break;
                }
            }
        }
    }
});
// CONCATENATED MODULE: ./src/mixin/confirmBox.js
/**
 * Created by xing.lin on 2019/6/28.
 */
/* harmony default export */ var confirmBox = ({
  methods: {
    contactMe: function contactMe() {
      this.$vux.confirm.show({
        content: this.$t('withdrawRecord.contactMe'),
        confirmText: this.$t('instruction.readBtn'),
        showCancelButton: false
      });
    }
  }
});
// CONCATENATED MODULE: ./src/mixin/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return global; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return local; });
/**
 * Created by xing.lin on 2019/6/11.
 */





var global = {
  error: error,
  info: info,
  confirmBox: confirmBox
};

var local = {
  formValidate: formValidate
};

/***/ }),

/***/ "j9pJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k6Vq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("VASZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ef9992","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')},"on-show":function($event){_vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("BaqE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oWtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7d30802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("us/H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qPUl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");
var clean_style_default = /*#__PURE__*/__webpack_require__.n(clean_style);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style_default.a
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style_default.a
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29eb1896","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("AROH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ruXm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ruXm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "us/H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4e43e04be7da729dc274.js